import { nowUtcIso } from '@/lib/dates'
import { openWorkspaceDb } from '@/offline/db'
import { atomicLocalWrite, buildOperation } from '@/offline/queue'
import { pushOutbox, type PushSummary } from '@/offline/sync'
import { supabaseTransport } from '@/offline/transport'
import type { BuiltSale } from './salePayload'

/**
 * Record a sale locally (sale row + device flipped to 'sold' in ONE transaction with its
 * outbox operation), then sync. The server re-enforces the double-sell lock and returns
 * 'already_sold' if the cycle was sold elsewhere.
 */
export async function saveSale(workspaceId: string, built: BuiltSale): Promise<PushSummary> {
  const db = openWorkspaceDb(workspaceId)
  const op = buildOperation({
    workspace_id: workspaceId,
    entity_id: built.sale.id,
    entity_type: 'sale',
    expected_revision: null,
    action: 'sale.create',
    payload: built.payload,
  })

  await atomicLocalWrite(
    db,
    [db.devices, db.sales],
    async () => {
      await db.sales.add(built.sale)
      await db.devices.update(built.deviceId, { status: 'sold', updated_at: nowUtcIso() })
    },
    op,
  )

  return pushOutbox(db, supabaseTransport())
}
